import { LinkProps } from 'react-router-dom';
import { removeLeadingBackslash } from 'react-scale/components/ExpertManagement/urls';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';

export const ToolsLink: React.FC<
  React.PropsWithoutRef<LinkProps> & React.RefAttributes<HTMLAnchorElement>
> = props => {
  const { isRemoAdmin } = useRemoAdminCtx();
  const urlPrefix = isRemoAdmin ? 'tools/' : '/corp/';
  return (
    <a
      {...props}
      href={urlPrefix + removeLeadingBackslash(props.to as string)}
      target="_blank"
      rel="noopener noreferrer"
    ></a>
  );
};
